/**
 * Pack builder — "Crea tu pack" (Gudslip).
 * Chips que filtran el grid en cliente (data-cats), cards que añaden AL PACK
 * (no al carrito), panel con tabs Compra única / Suscripción, tramos de
 * descuento (informativos: el descuento real lo aplica el código o descuento
 * automático de Shopify) y "Añadir al carrito": POST /cart/add.js con
 * items [{id, quantity(, selling_plan)}]; si el tramo alcanzado tiene código,
 * antes GET /discount/<código> (cookie de Shopify) y después dispara
 * `cart:updated` → iurop-cart-drawer.js refresca y ABRE el sidecart.
 * Ver NOTAS-DESARROLLO.md §3.23.
 */
(function () {
  'use strict';

  // Guard de reentrada (patrón iurop-product-card.js): el asset puede
  // re-evaluarse (theme editor, duplicados) → sin guard se duplicarían listeners.
  if (window.__iuropPackReady) return;
  window.__iuropPackReady = true;

  var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

  /* ---------------------------------------------------------------- money */

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Math.round(Number(cents) || 0);
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '€{{amount}}';

    function withDelimiters(number, precision, thousands, decimal) {
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var units = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return units + (parts[1] ? decimal + parts[1] : '');
    }

    var match = fmt.match(placeholderRegex);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = withDelimiters(cents, 2, ',', '.');
    }
    var out = fmt.replace(placeholderRegex, value);
    // Contrato iurop-money: en EUR el símbolo va a la DERECHA.
    if (out.indexOf('€') !== -1) {
      out = out.replace(/€/g, '').trim() + ' €';
    }
    return out;
  }

  /* ----------------------------------------------------------------- init */

  function init(root) {
    if (root.dataset.packInit) return;
    root.dataset.packInit = 'true';

    var moneyFormat = root.getAttribute('data-money-format') || '';
    var config = { tiers: [] };
    var configEl = root.querySelector('[data-pack-config]');
    if (configEl) {
      try {
        config = JSON.parse(configEl.textContent);
      } catch (err) {
        config = { tiers: [] };
      }
    }
    var tiers = (config.tiers || [])
      .slice()
      .sort(function (a, b) { return a.qty - b.qty; });

    var els = {
      grid: root.querySelector('[data-pack-grid]'),
      side: root.querySelector('[data-pack-side]'),
      items: root.querySelector('[data-pack-items]'),
      skeleton: root.querySelector('[data-pack-skeleton]'),
      next: root.querySelector('[data-pack-next]'),
      count: root.querySelector('[data-pack-count]'),
      total: root.querySelector('[data-pack-total]'),
      totalCompare: root.querySelector('[data-pack-total-compare]'),
      savings: root.querySelector('[data-pack-savings]'),
      submit: root.querySelector('[data-pack-submit]'),
      segs: root.querySelectorAll('[data-pack-seg]'),
      barCount: root.querySelector('[data-pack-bar-count]'),
      barTotal: root.querySelector('[data-pack-bar-total]'),
      template: root.querySelector('[data-pack-item-template]')
    };

    // Estado: items del pack (clave = variant id) + modo de compra.
    var state = { items: [], mode: 'one_time', busy: false };

    function findItem(id) {
      for (var i = 0; i < state.items.length; i++) {
        if (state.items[i].id === id) return state.items[i];
      }
      return null;
    }

    function totalQty() {
      return state.items.reduce(function (acc, it) { return acc + it.qty; }, 0);
    }

    function currentTier() {
      var qty = totalQty();
      var current = null;
      tiers.forEach(function (t) { if (qty >= t.qty) current = t; });
      return current;
    }

    function nextTier() {
      var qty = totalQty();
      for (var i = 0; i < tiers.length; i++) {
        if (qty < tiers[i].qty) return tiers[i];
      }
      return null;
    }

    function unitPrice(item) {
      if (state.mode === 'subscription' && item.sp && item.spPrice) return item.spPrice;
      return item.price;
    }

    /* ------------------------------------------------------------- render */

    function renderItems() {
      if (!els.items || !els.template) return;
      els.items.textContent = '';
      var tier = currentTier();
      var pct = tier ? tier.pct : 0;

      state.items.forEach(function (item) {
        var node = els.template.content.firstElementChild.cloneNode(true);
        node.setAttribute('data-id', item.id);

        var img = node.querySelector('[data-pack-item-img]');
        if (img) {
          if (item.image) {
            img.src = item.image;
            img.alt = item.title;
          } else {
            img.removeAttribute('src');
          }
        }
        var title = node.querySelector('[data-pack-item-title]');
        if (title) title.textContent = item.title;

        var variant = node.querySelector('[data-pack-item-variant]');
        if (variant && item.vtitle && item.vtitle !== 'Default Title') {
          variant.textContent = item.vtitle;
          variant.hidden = false;
        }

        // Línea: precio con el % del tramo aplicado VISUALMENTE + compare tachado.
        var lineBase = unitPrice(item) * item.qty;
        var lineFinal = Math.round(lineBase * (100 - pct) / 100);
        var lineCompare = 0;
        if (item.compare && item.compare > item.price) {
          lineCompare = item.compare * item.qty;
        } else if (pct > 0) {
          lineCompare = lineBase;
        }
        var price = node.querySelector('[data-pack-item-price]');
        if (price) price.textContent = formatMoney(lineFinal, moneyFormat);
        var compare = node.querySelector('[data-pack-item-compare]');
        if (compare && lineCompare > lineFinal) {
          compare.textContent = formatMoney(lineCompare, moneyFormat);
          compare.hidden = false;
        }

        var qty = node.querySelector('[data-pack-item-qty]');
        if (qty) qty.textContent = item.qty;

        els.items.appendChild(node);
      });
    }

    function renderPanel() {
      var qty = totalQty();
      var tier = currentTier();
      var next = nextTier();
      var pct = tier ? tier.pct : 0;

      // Mensaje del tramo siguiente (o del máximo alcanzado).
      if (els.next) {
        if (next) {
          var msg = els.next.getAttribute('data-msg-next') || '';
          els.next.innerHTML = msg
            .replace('[[count]]', next.qty)
            .replace('[[discount]]', next.label);
        } else if (tier) {
          var msgMax = els.next.getAttribute('data-msg-max') || '';
          els.next.innerHTML = msgMax.replace('[[discount]]', tier.label);
        }
      }

      // Barra segmentada: cada tramo se rellena entre el tramo anterior y el suyo.
      els.segs.forEach(function (seg, i) {
        if (!tiers[i]) return;
        var lo = i > 0 ? tiers[i - 1].qty : 0;
        var hi = tiers[i].qty;
        var ratio = hi > lo ? (qty - lo) / (hi - lo) : 0;
        ratio = Math.max(0, Math.min(1, ratio));
        seg.style.width = (ratio * 100) + '%';
      });

      // Contador.
      var countText = '';
      if (els.count) {
        countText = (els.count.getAttribute('data-msg-count') || '').replace('[[count]]', qty);
        els.count.textContent = countText;
      }

      // Lista / skeleton.
      var isEmpty = state.items.length === 0;
      if (els.items) els.items.hidden = isEmpty;
      if (els.skeleton) els.skeleton.hidden = !isEmpty;
      renderItems();

      // Total con el % del tramo aplicado visualmente.
      var subtotal = state.items.reduce(function (acc, it) {
        return acc + unitPrice(it) * it.qty;
      }, 0);
      var total = Math.round(subtotal * (100 - pct) / 100);
      var totalText = formatMoney(total, moneyFormat);
      if (els.total) els.total.textContent = totalText;

      // #32: precio tachado (antes del descuento/compare) + ahorro. El "compare"
      // total refleja lo mismo que las líneas: compare_at por ítem si existe, o el
      // base pre-tramo cuando hay % de tramo aplicado.
      var compareTotal = 0;
      state.items.forEach(function (it) {
        var base = unitPrice(it) * it.qty;
        var fin = Math.round(base * (100 - pct) / 100);
        var lc = 0;
        if (it.compare && it.compare > it.price) lc = it.compare * it.qty;
        else if (pct > 0) lc = base;
        compareTotal += (lc > fin) ? lc : fin;
      });
      var savings = compareTotal - total;
      if (els.totalCompare) {
        if (savings > 0) {
          els.totalCompare.textContent = formatMoney(compareTotal, moneyFormat);
          els.totalCompare.hidden = false;
        } else {
          els.totalCompare.hidden = true;
        }
      }
      if (els.savings) {
        if (savings > 0) {
          var tpl = els.savings.getAttribute('data-msg-savings') || '[[amount]]';
          els.savings.textContent = tpl.replace('[[amount]]', formatMoney(savings, moneyFormat));
          els.savings.hidden = false;
        } else {
          els.savings.hidden = true;
        }
      }

      // Barra móvil.
      if (els.barCount) els.barCount.textContent = countText;
      if (els.barTotal) els.barTotal.textContent = totalText;

      // CTA.
      if (els.submit) els.submit.disabled = isEmpty;
    }

    /* ------------------------------------------------------------- update */

    function addToPack(data) {
      var existing = findItem(data.id);
      if (existing) {
        existing.qty += data.qty;
      } else {
        state.items.push(data);
      }
      renderPanel();
      if (els.side && window.matchMedia('(max-width: 749px)').matches && !els.side.classList.contains('is-open')) {
        toggleSheet(true);
      }
    }

    function updateCardPrice(card, data) {
      var price = card.querySelector('[data-pack-price]');
      var compare = card.querySelector('[data-pack-compare]');
      var off = card.querySelector('[data-pack-off]');
      if (price) price.textContent = formatMoney(data.price, moneyFormat);
      // Un descuento que redondea a 0% no se enseña (p.ej. compare 28,20 vs 28,00)
      var pct = data.compare > data.price ? Math.round((data.compare - data.price) * 100 / data.compare) : 0;
      var hasOff = pct >= 1;
      if (compare) {
        compare.hidden = !hasOff;
        if (hasOff) compare.textContent = formatMoney(data.compare, moneyFormat);
      }
      if (off) {
        off.hidden = !hasOff;
        if (hasOff) {
          off.textContent = pct + '% OFF';
        }
      }
    }

    function toggleSheet(open) {
      if (!els.side) return;
      var isOpen = typeof open === 'boolean' ? open : !els.side.classList.contains('is-open');
      els.side.classList.toggle('is-open', isOpen);
      var bar = els.side.querySelector('[data-pack-toggle]');
      if (bar) bar.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    /* ------------------------------------------------------------- submit */

    function submitPack() {
      if (state.busy || !state.items.length || !els.submit) return;
      state.busy = true;
      els.submit.classList.add('is-loading');

      // #33: id único de pack → el sidecart agrupa estas líneas como "Pack creado".
      // `_pack_id` empieza por "_" → oculto para el cliente en carrito/checkout.
      var packId = 'p' + Date.now();
      var lines = state.items.map(function (it) {
        var line = { id: Number(it.id), quantity: it.qty, properties: { _pack_id: packId } };
        // Tab Suscripción: primer selling plan del producto si lo tiene;
        // sin selling plan se añade como compra normal (limitación documentada).
        if (state.mode === 'subscription' && it.sp) line.selling_plan = Number(it.sp);
        return line;
      });

      var tier = currentTier();
      var pre = tier && tier.code
        ? fetch('/discount/' + encodeURIComponent(tier.code)).catch(function () {})
        : Promise.resolve();

      pre
        .then(function () {
          return fetch(addUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: lines })
          });
        })
        .then(function (res) {
          state.busy = false;
          els.submit.classList.remove('is-loading');
          if (!res || !res.ok) return;
          // Pack añadido: vaciamos y dejamos que el sidecart tome el relevo.
          state.items = [];
          renderPanel();
          toggleSheet(false);
          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch(function () {
          state.busy = false;
          els.submit.classList.remove('is-loading');
        });
    }

    /* ------------------------------------------------------------- events */

    root.addEventListener('click', function (e) {
      // Chips: filtro en cliente.
      var chip = e.target.closest('[data-pack-filter]');
      if (chip && root.contains(chip)) {
        var handle = chip.getAttribute('data-pack-filter') || '';
        root.querySelectorAll('[data-pack-filter]').forEach(function (c) {
          var active = c === chip;
          c.classList.toggle('is-active', active);
          c.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        root.querySelectorAll('[data-pack-card]').forEach(function (card) {
          var cats = card.getAttribute('data-cats') || '';
          var show = !handle || cats.indexOf(' ' + handle + ' ') !== -1;
          card.classList.toggle('is-filtered', !show);
        });
        return;
      }

      // Stepper de card (productos sin variantes).
      var qtyMinus = e.target.closest('[data-pack-qty-minus]');
      var qtyPlus = e.target.closest('[data-pack-qty-plus]');
      if (qtyMinus || qtyPlus) {
        var qtyWrap = (qtyMinus || qtyPlus).closest('[data-pack-qty]');
        var valueEl = qtyWrap && qtyWrap.querySelector('[data-pack-qty-value]');
        if (valueEl) {
          var val = parseInt(valueEl.textContent, 10) || 1;
          val = qtyPlus ? Math.min(99, val + 1) : Math.max(1, val - 1);
          valueEl.textContent = val;
        }
        return;
      }

      // Añadir AL PACK.
      var addBtn = e.target.closest('[data-pack-add]');
      if (addBtn && root.contains(addBtn)) {
        var card = addBtn.closest('[data-pack-card]');
        if (!card || addBtn.hasAttribute('disabled')) return;
        var cardQtyEl = card.querySelector('[data-pack-qty-value]');
        var qty = cardQtyEl ? (parseInt(cardQtyEl.textContent, 10) || 1) : 1;
        addToPack({
          id: addBtn.getAttribute('data-variant-id'),
          qty: qty,
          price: Number(addBtn.getAttribute('data-price')) || 0,
          compare: Number(addBtn.getAttribute('data-compare')) || 0,
          sp: addBtn.getAttribute('data-sp') || '',
          spPrice: Number(addBtn.getAttribute('data-sp-price')) || 0,
          vtitle: addBtn.getAttribute('data-vtitle') || '',
          title: card.getAttribute('data-title') || '',
          image: card.getAttribute('data-image') || '',
          url: card.getAttribute('data-url') || ''
        });
        addBtn.classList.add('is-added');
        window.setTimeout(function () { addBtn.classList.remove('is-added'); }, 900);
        return;
      }

      // Tabs Compra única / Suscripción.
      var tab = e.target.closest('[data-pack-mode]');
      if (tab && root.contains(tab)) {
        state.mode = tab.getAttribute('data-pack-mode') || 'one_time';
        root.querySelectorAll('[data-pack-mode]').forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        renderPanel();
        return;
      }

      // Steppers y papelera de la lista del pack.
      var itemRow = e.target.closest('[data-pack-item]');
      if (itemRow && root.contains(itemRow)) {
        var item = findItem(itemRow.getAttribute('data-id'));
        if (!item) return;
        if (e.target.closest('[data-pack-item-plus]')) {
          item.qty = Math.min(99, item.qty + 1);
        } else if (e.target.closest('[data-pack-item-minus]')) {
          item.qty -= 1;
          if (item.qty < 1) state.items.splice(state.items.indexOf(item), 1);
        } else if (e.target.closest('[data-pack-item-remove]')) {
          state.items.splice(state.items.indexOf(item), 1);
        } else {
          return;
        }
        renderPanel();
        return;
      }

      // Barra móvil plegable.
      if (e.target.closest('[data-pack-toggle]')) {
        toggleSheet();
        return;
      }

      // Añadir al carrito.
      if (e.target.closest('[data-pack-submit]')) {
        submitPack();
      }
    });

    // Dropdown de variantes: actualiza precio, %OFF y datos del botón.
    root.addEventListener('change', function (e) {
      var select = e.target.closest('[data-pack-variant]');
      if (!select || !root.contains(select)) return;
      var option = select.options[select.selectedIndex];
      if (!option) return;
      var card = select.closest('[data-pack-card]');
      var addBtn = card && card.querySelector('[data-pack-add]');
      if (!addBtn) return;
      addBtn.setAttribute('data-variant-id', option.value);
      addBtn.setAttribute('data-price', option.getAttribute('data-price') || '0');
      addBtn.setAttribute('data-compare', option.getAttribute('data-compare') || '0');
      addBtn.setAttribute('data-vtitle', option.getAttribute('data-vtitle') || '');
      addBtn.setAttribute('data-sp', option.getAttribute('data-sp') || '');
      addBtn.setAttribute('data-sp-price', option.getAttribute('data-sp-price') || '');
      if (option.disabled) {
        addBtn.setAttribute('disabled', '');
      } else {
        addBtn.removeAttribute('disabled');
      }
      updateCardPrice(card, {
        price: Number(option.getAttribute('data-price')) || 0,
        compare: Number(option.getAttribute('data-compare')) || 0
      });
    });

    renderPanel();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-pack]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init al recargar la sección.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
